module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3461589.26ecb9da.png";